import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/App.css';
import logo from '../assets/images/phonemousewhite.svg';

const IOSReview = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <div className="page-container">
      <div className="legal-section-container">
        <div className="support-content">
          <img src={logo} className="App-logo" alt="AirMouse Logo" style={{height: '20vmin', marginBottom: '2rem'}} />
          
          <h2>iOS App Coming Soon!</h2>
          
          <div style={{marginBottom: '2rem'}}>
            <p>
              Our iOS app is currently under review by Apple's team. 
              We're working hard to bring you the best possible experience!
            </p>
            
            <p>
              Once approved, the download link will automatically redirect you to the App Store. 
              Thank you for your patience!
            </p>
          </div>
          
          <div style={{marginTop: '2rem'}}>
            <button onClick={handleGoBack} className="ios-review-back-button">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
              </svg>
              Back to Home
            </button>
          </div>
        </div>
      </div>

      <div className="support-container">
        <div className="support-content">
          <h2>Need More Help?</h2>
          <p>If you have additional questions or need further assistance, our support team is here to help.</p>
          <div className="support-email">
            <span className="email-label">Contact us at:</span>
            <a href="mailto:airmouse.help@gmail.com" className="support-email-link">
              airmouse.help@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IOSReview;